module.exports = __webpack_public_path__ + "img/logo-b.b073b9f4.png";